import comp from "./AiQuestionGeneratorWrapper";
export default comp;
